//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DisparityTag from './DisparityTag.vue'
export default {
  name: 'SupervisorValidationTable',
  components: {
    DisparityTag,
  },
  props: {
    collaborators: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sortableColumns: {
        collaborator_match: 'asc',
        supervisor_match: 'asc',
        disparity: 'asc',
      },
    }
  },
  methods: {
    handleSort(field, order) {
      this.sortableColumns[field] = order
    },
    findSkillsValidated(supervisorAssignment) {
      this.$emit('handleSkillsValidations', supervisorAssignment)
    },
  },
}
